import { render, staticRenderFns } from "./TaskManagement.vue?vue&type=template&id=288285ec&scoped=true"
import script from "./TaskManagement.vue?vue&type=script&lang=js"
export * from "./TaskManagement.vue?vue&type=script&lang=js"
import style0 from "./TaskManagement.vue?vue&type=style&index=0&id=288285ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288285ec",
  null
  
)

export default component.exports